import React from 'react';
import './IITStrip.css';

const CONTACT_US_QUERY = `Hi CampusXL, I would like to know more about the programs you offer with IIT, Mandi. Shall I get a call from you side?\nThanks.`;

const IITStrip = ({ onApplyNow }) => {
  return (
    <div className="iit-strip">
      <div className="iit-strip-glow" />
      <div className="iit-strip-inner">

        {/* Badge */}
        <div className="iit-badge">
          <span className="iit-badge-dot" />
          <span className="iit-badge-text">Announcement</span>
        </div>

        {/* Text block + Logo */}
        <div className="iit-content-group">
          <div className="iit-text-block">
            <p className="iit-headline">
              Now your degree holds&nbsp;
              <span className="iit-headline-accent">more value!</span>
            </p>
            <p className="iit-subtext">
              Your dream of an&nbsp;
              <span className="kw kw--gold">IIT</span>
              &nbsp;degree comes true — B.Tech CS and BCA integrated with&nbsp;
              <span className="kw kw--gold">IIT Mandi</span>
              &nbsp;minor degree in&nbsp;
              <span className="kw kw--cyan">AI</span>.
              &nbsp;Contact us for more information.
            </p>
          </div>

          {/* IIT Mandi Logo */}
          <div className="iit-logo-block">
            <img src="/logos/iitlogo.png" alt="IIT Mandi" className="iit-logo-img" />
          </div>
        </div>

        {/* CTA */}
        <button className="iit-cta" onClick={() => onApplyNow(CONTACT_US_QUERY)}>
          Contact Us
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </button>

      </div>
    </div>
  );
};

export default IITStrip;
